import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "budget-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "hr mb-0" }, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "hr mb-0" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_base_input = _resolveComponent("base-input")

  return (!!_ctx.ContractId && !!_ctx.offerPersonId)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.codes, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: item.codeId,
            class: "budget-wrapper__item"
          }, [
            (item.isEnum)
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  _createVNode("label", {
                    for: item.codeName
                  }, _toDisplayString(item.codeName), 9, ["for"]),
                  _createVNode(_component_Dropdown, {
                    modelValue: item.codeValue,
                    "onUpdate:modelValue": $event => (item.codeValue = $event),
                    options: item.codeEnumList,
                    optionLabel: "entityName",
                    placeholder: "Выберите бюджетный код",
                    id: item.codeName,
                    disabled: item.isReadOnly
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "id", "disabled"])
                ]))
              : (_openBlock(), _createBlock(_component_base_input, {
                  key: 1,
                  name: item.codeName,
                  value: item.codeValue,
                  label: item.codeName,
                  onInput: $event => (_ctx.simpleSetData($event, index)),
                  disabled: item.isReadOnly
                }, null, 8, ["name", "value", "label", "onInput", "disabled"]))
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        _hoisted_4
      ]))
    : _createCommentVNode("", true)
}